<template>
  <v-overlay class="layering">
    <v-card
      :color="`${background_color ? background_color : 'backgroundLight'}`"
      :light="!this.$vuetify.theme.dark"
      class="pb-4"
      :style="`width: ${width ? width : '80vw'}; max-height: 80vh; overflow:hidden`"
    >
      <div v-if="show_header || !hide_close_button" class="overlay-header">
        <v-toolbar dense class="add-opacity" :color="`${header_color ? header_color : 'backgroundLight'}`" :flat="true">
          <v-toolbar-title v-if="open_as_page && open_as_page_url" class="title primaryGrey--text">
            <router-link :to="open_as_page_url">
              <v-icon class="mr-3" small color="primaryGrey">mdi-open-in-new</v-icon
              >{{ $t("common.labels.openAsPage") }}
            </router-link>
          </v-toolbar-title>
          <div v-if="!hide_close_button" class="close-btn">
            <v-btn @click="closeDialog" fixed outlined color="primaryGrey" class="py-4" x-small>
              <v-icon small color="primaryGrey">mdi-close</v-icon>
            </v-btn>
          </div>
        </v-toolbar>
      </div>
      <div :class="`overlay-content ${!no_content_padding ? 'px-6 pb-6' : ''}`">
        <slot name="content"></slot>
      </div>
    </v-card>
  </v-overlay>
</template>

<script>
export default {
  name: "CustomOverlay",
  props: {
    show_header: {
      type: Boolean,
    },
    open_as_page: {
      type: Boolean,
    },
    open_as_page_url: {
      type: String,
    },
    hide_close_button: {
      type: Boolean,
    },
    no_content_padding: {
      type: Boolean,
    },
    width: {
      type: String,
    },
    background_color: {
      type: String,
    },
    header_color: {
      type: String,
    },
  },
  data: function () {
    return {
      config: null,
      chip_label: null,
      tooltip_label: null,
    };
  },
  created() {},
  mounted() {
    document.body.classList.add("no-scroll");
  },
  methods: {
    closeDialog() {
      this.$emit("close");
    },
  },
  beforeDestroy() {
    document.body.classList.remove("no-scroll");
  },
};
</script>
<style scoped>
.close-btn {
  position: absolute;
  top: 1em;
  right: 0;
  z-index: 9;
  padding-right: 4em;
}

.overlay-header {
  position: relative;
  max-height: 48px;
}

.overlay-content {
  position: relative;
  top: 15px;
  max-height: 75vh;
  overflow: auto;
}
.title {
  height: inherit;
  align-content: flex-end;
  font-size: 0.75rem !important;
  font-family: Trade Gothic Regular !important;
}
</style>
